import executeRequest, { RequestOutput } from 'app/api'
// import { RequestOutput } from 'app/api'

export type API_GetConfig = {
	type: string
  app: {
    serverUrl: string
    i18nUrl: string
    merchantUrl: string
  }
  service: {
    GELSDK: {
      scriptUrl: string
      options: {
        urlEndUser: string
        isReturnOrder: boolean
        locale: string
      }
    }
    mapTiler: {
      mapId: string
      apiKey: string
    }
    tagManager: {
      enable: boolean
      key: string
    }
  }
}


type GetConfigResponse = API_GetConfig
enum GetConfigReponseError {
}
export async function getConfig(output?: RequestOutput<GetConfigResponse, GetConfigReponseError>) {
  let endpoint = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_CONFIG_DEV_URL : process.env.REACT_APP_CONFIG_URL

  if (endpoint == null) {
    console.error('Configuration file path not provided. Aborting.')
    return
  }

  executeRequest({
    baseUrl: process.env.PUBLIC_URL + '/',
    endpoint: endpoint,
    type: 'GET',
    output: output,
  })
  return
}
